import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d210687")

_pushScopeId("data-v-4d210687")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "label" }, "First Name", -1)
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Last Name", -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Company Name", -1)
const _hoisted_10 = { class: "control" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Address Line 1", -1)
const _hoisted_13 = { class: "control" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Address Line 2", -1)
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Town", -1)
const _hoisted_19 = { class: "control" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Zip/Postal Code", -1)
const _hoisted_22 = { class: "control" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "label" }, "State/Province", -1)
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Country", -1)
const _hoisted_28 = { class: "control" }
const _hoisted_29 = { class: "select" }
const _hoisted_30 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Select your country", -1)
const _hoisted_31 = { class: "field" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Telephone", -1)
const _hoisted_33 = { class: "control" }
const _hoisted_34 = { class: "field" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Fax Number", -1)
const _hoisted_36 = { class: "control" }
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Email", -1)
const _hoisted_39 = { class: "control" }
const _hoisted_40 = { class: "buttons is-centered mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAddress && _ctx.submitAddress(...args)), ["prevent"])),
      class: "address-form"
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("input", {
            value: _ctx.address.FirstName,
            type: "text",
            class: "input",
            placeholder: "Enter your first name",
            required: "",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateAddress('FirstName', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("input", {
            value: _ctx.address.LastName,
            type: "text",
            class: "input",
            placeholder: "Enter your last name",
            required: "",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateAddress('LastName', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("input", {
            value: _ctx.address.CompanyName,
            type: "text",
            class: "input",
            placeholder: "Enter your company name",
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateAddress('CompanyName', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("input", {
            value: _ctx.address.AddressLine1,
            type: "text",
            class: "input",
            placeholder: "Enter address line 1",
            required: "",
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateAddress('AddressLine1', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("div", _hoisted_16, [
          _createVNode("input", {
            value: _ctx.address.AddressLine2,
            type: "text",
            class: "input",
            placeholder: "Enter address line 2",
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateAddress('AddressLine2', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode("input", {
            value: _ctx.address.Town,
            type: "text",
            class: "input",
            placeholder: "Enter your town",
            required: "",
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateAddress('Town', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, [
          _createVNode("input", {
            value: _ctx.address.ZipPostalCode,
            type: "text",
            class: "input",
            placeholder: "Enter your zip/postal code",
            required: "",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateAddress('ZipPostalCode', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode("div", _hoisted_25, [
          _createVNode("input", {
            value: _ctx.address.StateProvince,
            type: "text",
            class: "input",
            placeholder: "Enter your state/province",
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateAddress('StateProvince', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_26, [
        _hoisted_27,
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("select", {
              value: _ctx.address.Country,
              required: "",
              onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateAddress('Country', $event.target.value)))
            }, [
              _hoisted_30,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                return (_openBlock(), _createBlock("option", {
                  key: country,
                  value: country
                }, _toDisplayString(country), 9, ["value"]))
              }), 128))
            ], 40, ["value"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _hoisted_32,
        _createVNode("div", _hoisted_33, [
          _createVNode("input", {
            value: _ctx.address.Telephone,
            type: "tel",
            class: "input",
            placeholder: "Enter your telephone number",
            required: "",
            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateAddress('Telephone', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode("div", _hoisted_36, [
          _createVNode("input", {
            value: _ctx.address.FaxNumber,
            type: "text",
            class: "input",
            placeholder: "Enter your fax number",
            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateAddress('FaxNumber', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _hoisted_38,
        _createVNode("div", _hoisted_39, [
          _createVNode("input", {
            value: _ctx.address.Email,
            type: "email",
            class: "input",
            placeholder: "Enter your email address",
            required: "",
            onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateAddress('Email', $event.target.value)))
          }, null, 40, ["value"])
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _createVNode("button", {
          type: "reset",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearForm && _ctx.clearForm(...args))),
          class: "button is-warning"
        }, "Clear Form")
      ])
    ], 32)
  ]))
})